import React from 'react';
import '../../../styles/SelectCoin/CoinCard.css'; 

const ChainCard = ({ coin, chainLogo, handleCoinSelect }) => {

  return (
    <div className={`coin-card-container chain-card-container`} onClick={handleCoinSelect}>
      <div className="chain-card">
        <img className="coin-logo" src={chainLogo} alt={coin.chain.name} />
        <div className="chain-name-container">
          <h3 className="coin-name">{coin.chain.name}</h3>
        </div>
      </div>
    </div>
  );
};

export default ChainCard;